<ion-content class="ion-padding" [scrollY]="false" [scrollX]="false" slot="fixed">
  <img src="/assets/images/logo-yova.png" alt="Logo yova" />
  <div class="onboarding--center">
    <h1>{{ 'PUBLIC.onboarding.title' | translate }}</h1>
    <p>{{ 'PUBLIC.onboarding.instructions' | translate }}</p>
    <ion-button mode="ios" expand="block" data-cy="public.onboarding.submit" (click)="goToStrategy()">
      <ion-icon slot="end" name="log-in-outline"></ion-icon>
      {{ 'PUBLIC.onboarding.cta' | translate }}
    </ion-button>
  </div>
</ion-content>
